import React from 'react'
import { Spinner } from 'react-bootstrap'

interface UnifiedSearchEmptyStateProps {
  debouncedSearchTerm: string
  isLoading: boolean
  selectedTab: 'firstbite' | 'unmatched' | 'firstbitedoors' | 'unmatcheddoors'
  hasResults: boolean
}

export function UnifiedSearchEmptyState({
  debouncedSearchTerm,
  isLoading,
  selectedTab,
  hasResults,
}: UnifiedSearchEmptyStateProps) {
  if (!debouncedSearchTerm) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-gray-500 text-lg">Start typing to search...</p>
          <p className="text-gray-400 text-sm">
            Search across all opportunity types by name, domain, or address
          </p>
        </div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Spinner />
      </div>
    )
  }

  if (!hasResults) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-gray-500 text-lg">
            {selectedTab === 'firstbite'
              ? 'No First Bite chain results found'
              : selectedTab === 'firstbitedoors'
                ? 'No First Bite door results found'
                : selectedTab === 'unmatcheddoors'
                  ? 'No unmatched door results found'
                  : 'No unmatched chain results found'}
          </p>
          <p className="text-gray-400 text-sm">
            Try adjusting your search or filters
          </p>
        </div>
      </div>
    )
  }

  return null
}
